import "../../style/slider-wrapper.css"
import { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Left from '../../images/previous.svg';
import Right from '../../images/next.svg';
// import { SliderImagePlaceHolder } from '../utils/ImagePlaceholder'
import LazyLoadImage from './LazyLoadImage'
import { BASE_URL } from '../../variables'
// const SliderWrapper = ({ height, sliderItemData, heading, to, mobileNav, extraInnerWidth, loading, setLoading }) => {
const SliderWrapper = ({ height, sliderItemData, heading, to, mobileNav, extraInnerWidth }) => {
    const outerSilder = useRef()
    const innerSlider = useRef()
    const [innerSliderWidth, setInnerSliderWidth] = useState(0)
    const [sliderItemWidth, setSliderItemWidth] = useState(0)
    const currentTranslation = useRef(0)
    const screenWidth = window.innerWidth

    
    useEffect(() => {
        if (screenWidth > 700 && screenWidth < 1215){
            setSliderItemWidth(outerSilder.current.clientWidth / 3 - 10)
        }
        else if (screenWidth >= 1215){
            setSliderItemWidth(outerSilder.current.clientWidth / 4 - 10)
        }
        setInnerSliderWidth(sliderItemWidth * sliderItemData.length + 45 + extraInnerWidth)
    }, [screenWidth, sliderItemWidth, extraInnerWidth, sliderItemData.length])
    

    const sliderLeft = () => {
        let scrollable
        if (screenWidth > 700 && screenWidth < 1215){
            scrollable = (sliderItemData.length - 3) * (outerSilder.current.clientWidth / 3)
            if (currentTranslation.current > -scrollable){
                currentTranslation.current = currentTranslation.current - outerSilder.current.clientWidth / 3
            innerSlider.current.style.transform = `translateX(${currentTranslation.current}px)`
            }
                                
        }
        else{
            scrollable = (sliderItemData.length - 4) * (outerSilder.current.clientWidth / 4)
            if (currentTranslation.current > -scrollable){
                currentTranslation.current = currentTranslation.current - outerSilder.current.clientWidth / 4    
                innerSlider.current.style.transform = `translateX(${currentTranslation.current}px)`
            }
            
            
            
        }
    }
    const sliderRight = () => {
        if (screenWidth > 700 && screenWidth < 1215){
           if (currentTranslation.current < 0){
            currentTranslation.current = currentTranslation.current + outerSilder.current.clientWidth / 3
            innerSlider.current.style.transform = `translateX(${currentTranslation.current}px)`
           }

        }
        else{
            if (currentTranslation.current < 0){
                currentTranslation.current = currentTranslation.current + outerSilder.current.clientWidth / 4    
                innerSlider.current.style.transform = `translateX(${currentTranslation.current}px)`
            }
        }
    }

    // const imageLoaded = () => {
    //     setLoading(false)
    // }
    const renderSliderItem = sliderItemData.map(x => {
        return (
            <Link to={to} style={{width: mobileNav ? "240px" : `${sliderItemWidth}px`, backgroundColor: 'white', height: '100%', borderRadius: '5px', overflow: "hidden"}} key={x.id} className="slider-item-link">
                <p style={{position: 'absolute', color: 'black', textAlign: 'center', width: '100%', bottom: '0px', marginBottom: '15px', whiteSpace: 'nowrap', fontSize: '16px', fontWeight: 'bolder'}}>{x.name.length > 16 ? x.name.substring(0, 14) + ".." : x.name}</p>
                {/* <img src={`${BASE_URL + x.icon}`} alt="cleaning_service" width={mobileNav ? "263px" : `${sliderItemWidth}px`} style={{borderRadius: '5px', display: loading ? "none" : 'block'}} onLoad={imageLoaded} />
                {loading ? <SliderImagePlaceHolder width={`${mobileNav ? 263-12 : sliderItemWidth-12}px`} height={`${mobileNav ? 135 : 155}px`}/> : ""} */}
                <LazyLoadImage height={height} width={mobileNav ? "241px" : `${sliderItemWidth}px`} src={`${BASE_URL + x.icon}`} style={{borderRadius: '5px', display: 'block'}} alt="cleaning_service"/>
            </Link>
        )
    })
    const renderSliderHandle = () => {
        if (mobileNav){
            return null
        }
        return(
            <>
                <img src={Left} className="slider-handle-left" width={35} height={35} alt="left icon" style={{top: mobileNav ? '48%' : '55%'}} onClick={sliderLeft}/>
                <img src={Right} className="slider-handle-right" width={35} height={35} alt="left icon" style={{top: mobileNav ? '48%' : '55%'}} onClick={sliderRight}/>
            </>
        )
    }
    
    const innerSliderStyle = mobileNav ? {width: "100%"} : {transform: 'translateX(0px)', width: innerSliderWidth, transition: 'all 0.4s'}
    return (
        <div className="containerAF max-width slider-container-top">
            <h2 className="slider-title">{heading}</h2>
            {renderSliderHandle()}
            <div className="slider-container" style={{height: height}}>
                <div className="outer-slider" ref={outerSilder}>
                    <div className="inner-slider" style={innerSliderStyle} ref={innerSlider}>
                        {renderSliderItem}
                    </div>
                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return{
        mobileNav: state.mobileNav
    }
}   
export default connect(mapStateToProps)(SliderWrapper)


